import React from "react";
import "./InterviewDetail.scss";
import { Steps, Toast, WingBlank, Button, Tag, Modal } from "antd-mobile";
import http from "../../util/api";
import GoBack from "../../components/GoBack";
import { getItem } from "../../util/util";
import withAuth from "../../HOCs/withAuth";

const alert = Modal.alert;
const { Step } = Steps;

const resid = "617278498676";
class InterviewDetail extends React.Component {
  state = {
    interviewDetail: {},
    componayGuid: JSON.parse(getItem("componay_guide")),
    loading: true
  };

  async componentDidMount() {
    this.setState({
      loading: true
    });
    window.V5CHAT("hideBtn");
    Toast.loading("loading...", 0);
    const id = this.props.match.params.id;
    await this.getInterviewDetail(id);
    this.setState({
      loading: false
    });
  }

  //取消面试
  cancelInterview = async () => {
    try {
      let res = await http().modifyRecords({
        resid,
        data: [{ ...this.state.interviewDetail, isOrdered: "N" }]
      });
      this.setState({ interviewDetail: res.data.data[0] });
      Toast.info("面试已取消");
    } catch (error) {
      console.log(error.message);
      Toast.fail(error.message);
    }
  };

  //获取面试详情
  getInterviewDetail = async id => {
    try {
      let res = await http().getTable({
        resid,
        cmswhere: `interviewId = ${id}`
      });
      let { data } = res;
      if (data.data.length) {
        this.setState({ interviewDetail: data.data[0] });
        Toast.hide();
      } else {
        Toast.info("无面试信息", 2, () => {
          this.props.history.push("/interviews");
        });
      }
    } catch (error) {
      console.log(error.message);
      Toast.fail(error.message);
    }
  };

  goBack = () => this.props.history.push("/interviews");

  render() {
    const { interviewDetail } = this.state;
    let current = 0;
    let testResultStatus, interviewResultStatus;
    if (interviewDetail.checkIn === "Y") {
      current = 1;
    }
    if (interviewDetail.testResult) {
      current = 2;
      if (interviewDetail.testResult === "通过") {
        testResultStatus = "finish";
      } else if (interviewDetail.testResult === "未通过") {
        testResultStatus = "error";
        interviewResultStatus = "error";
      }
    }
    if (interviewDetail.interviewResult) {
      current = 3;
      if (interviewDetail.interviewResult === "合格") {
        interviewResultStatus = "finish";
      } else if (interviewDetail.interviewResult === "不合格") {
        interviewResultStatus = "error";
      }
    }

    console.log(current);
    const isWaitingInterview = interviewDetail.C3_617728767339 === "待面试";
    const isValid = interviewDetail.C3_617728767339 !== "已取消";
    return this.state.loading ? (
      <div />
    ) : (
      <div className="interview_detail">
        <GoBack goBack={this.goBack} />
        <div>
          <div className="position_info">
            <div className="title_salary">
              <span className="pisition_title"> {interviewDetail.job}</span>
              <span className="position_salary">
                {interviewDetail.salary}/月
              </span>
            </div>
            {isWaitingInterview && (
              <div className="appointment_time">
                <span>面试时间</span>
                <span>{interviewDetail.interviewTime}</span>
              </div>
            )}
            {isValid && (
              <div className="steps">
                <Steps current={current} direction="horizontal">
                  <Step title="考试签到" />
                  <Step status={testResultStatus} title="手机考试" />
                  <Step status={interviewResultStatus} title="专人面试" />
                </Steps>
              </div>
            )}
          </div>
          {!isWaitingInterview && (
            <div className="interview_infos">
              <div>
                <span>面试时间</span>
                <span>{interviewDetail.interviewTime}</span>
              </div>

              {isValid ? (
                <React.Fragment>
                  <div>
                    <span>考试时间</span>
                    <span>{interviewDetail.C3_617724261149}</span>
                  </div>
                  <div>
                    <span>考试结果</span>
                    <span className="interview_result">
                      {interviewDetail.testResult}
                    </span>
                  </div>
                  <div>
                    <span>面试结果</span>
                    <span className="interview_result">
                      {interviewDetail.interviewResult}
                    </span>
                  </div>
                </React.Fragment>
              ) : (
                <div className="interview_not_valid">
                  面试{interviewDetail.C3_617728767339}
                </div>
              )}
            </div>
          )}
          <div className="enterprise_info">
            <h4>公司向导</h4>
            <p>
              <span>地址:</span> {this.state.componayGuid.address}
            </p>
            <p>
              <span>公交:</span> {this.state.componayGuid.transit}
            </p>
            <p>
              <span>电话:</span> {this.state.componayGuid.phone}
            </p>
            {/* <p>传真: 88888888</p>
            <p>电邮: 888@xx.com</p> */}
          </div>
          <div className="position_descrition">
            <h3>职位描述</h3>
            <div className="description_main">
              <p>{interviewDetail.jobDis}</p>
              <div className="position_tags">
                {interviewDetail.C3_617811708424.split(",").map(item => (
                  <Tag key={item}>{item}</Tag>
                ))}
              </div>
            </div>
          </div>
          {isWaitingInterview && (
            <WingBlank className="cancel_btn">
              <Button
                onClick={() =>
                  alert("取消预约?", "", [
                    { text: "取消", onPress: () => console.log("cancel") },
                    { text: "确认", onPress: this.cancelInterview }
                  ])
                }
                type="warning"
              >
                取消面试
              </Button>
            </WingBlank>
          )}
        </div>
      </div>
    );
  }
}

export default withAuth(InterviewDetail);
